﻿import { registerPlugin, initOptions, loadOptions } from "../plugin";
import { minmax, round, forceReflow, bindInputButtonsDisabled, scrollIntoView, preventScrolling, stackElements } from "../util";

var inputWrapperClass = "ff-input-wrapper";

// Defines default options for the timePicker plugin.
var timePickerDefaults = {
};

// Converts each selected date/time input element into a masked text field with time picker button.
function timePicker(options) {
	return this.each(function () {
		var input = $(this);
		if (input.parent().hasClass(inputWrapperClass)) return;   // Already done
		var opt = initOptions("timePicker", timePickerDefaults, input, {}, options);
		var originalType = input.attr("type").trim().toLower();
		var step = +input.attr("step") || 1;
		var dateSelection = originalType === "date" || originalType === "datetime-local" || originalType === "month" || originalType === "week";
		var weekSelection = originalType === "week";
		var daySelection = originalType === "date" || originalType === "datetime-local";
		var timeSelection = originalType === "datetime-local" || originalType === "time";
		var minuteSelection = timeSelection && step < 3600;
		var secondSelection = timeSelection && step < 60;
		// TODO: Continue here...
		var lastColor;

		input.attr("type", "text").attr("autocomplete", "off");

		// Put a wrapper between the input and its parent
		var wrapper = $("<div/>").addClass(inputWrapperClass).attr("style", input.attr("style"));
		input.before(wrapper).appendTo(wrapper);

		// Create picker dropdown
		var dropdown = $("<div/>").addClass("dropdown bordered ff-colorpicker");
		dropdown.keydown(function (event) {
			if (event.keyCode >= 37 && event.keyCode <= 40) {   // Arrow keys
				event.preventDefault();
				dropdown.find("button").first().focus();
				dropdown.removeAttr("tabindex");
			}
			if (event.keyCode === 27) {   // Esc
				event.preventDefault();
				dropdown.dropdown.close();
				pickButton[0].focus();
			}
		});

		// Add control buttons
		var buttons = [];
		var pickButton = $("<button type='button'/>").addClass("ff-colorbutton").appendTo(wrapper);
		buttons.push(pickButton);
		var colorBox = $("<div/>").appendTo(pickButton).text("\u2026");   // &hellip;
		input.on("input change", () => setColor(lastColor = input.val()));
		setColor(lastColor = input.val());

		// Create dropdown contents
		// TODO

		pickButton.click(function (event) {
			var currentColor = input.val();
			var activeButton;
			dropdown.find("button").each$(function () {
				var active = this.data("color") === currentColor;
				this.toggleClass("active", active);
				if (active) activeButton = this[0];
			});

			dropdown.dropdown(pickButton, { placement: "right" });
			if (activeButton) {
				activeButton.focus();
			}
			else {
				dropdown.attr("tabindex", "-1");
				dropdown.focus();
			}
		});
		bindInputButtonsDisabled(input, buttons);

		function setColor(color, toInput) {
			if (toInput && input.val() != color) {
				input.val(color).trigger("input").change();
			}
		}
	});
}

registerPlugin("timePicker", timePicker);
